module.exports = __webpack_public_path__ + "static/img/male-tablet.ef6690c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/male-tablet.gif
// module id = 1202
// module chunks = 1